import { render, staticRenderFns } from "./MobileSidebar.vue?vue&type=template&id=9508a85e&scoped=true"
import script from "./MobileSidebar.vue?vue&type=script&lang=js"
export * from "./MobileSidebar.vue?vue&type=script&lang=js"
import style0 from "./MobileSidebar.vue?vue&type=style&index=0&id=9508a85e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9508a85e",
  null
  
)

export default component.exports